<template>
  <div>
    <!-- 1. Update Existing Association with Organizational Units -->
    <div class="mt-2 mb-4 ml-2">
      <h6 class="text-primary">
        {{ __('forms.peopleOrganizazionalUnit.editExistingPersonOrganizationalUnit') }}
      </h6>

      <div class="alert alert-warning mt-2">
        {{ __('forms.peopleOrganizationalUnit.disclaimer') }}
      </div>

      <form method="POST" :action="'/person-organizational-units/' + person.id + '/update-data'" accept-charset="UTF-8"
        enctype="multipart/form-data">
        <input type="hidden" name="_token" :value="csrf">
        <input type="hidden" name="_method" value="PUT">


        <div class="single--item mt-4 ml-2">
          <div class="row">
            <div class="col-3">
              <div class="single--item-info">
                <h6 class="text-secondary-heading ml-2">{{ __('forms.Person.organizational_units_typology') }}</h6>
              </div>
            </div>
            <div class="col-3">
              <div class="single--item-info">
                <h6 class="text-secondary-heading ml-2">{{ __('forms.Person.organizational_units_names') }}</h6>
              </div>
            </div>
            <div class="col-1">
              <div class="single--item-info">
                <h6 class="text-secondary-heading ml-2">{{ __('forms.PeopleRoles.fte') }}</h6>
              </div>
            </div>
            <div class="col-2">
              <div class="single--item-info">
                <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.started_at') }}</h6>
              </div>
            </div>
            <div class="col-2">
              <div class="single--item-info">
                <h6 class="text-secondary-heading ml-2">{{ __('views.trainingRequestCourse.ended_at') }}</h6>
              </div>
            </div>
            <div class="col-1">
              <div class="single--item-button"></div>
              <h6 class="text-secondary-heading">{{ __('views.trainingRequests.actions') }}</h6>
            </div>
          </div>
        </div>

        <div class="single--item mb-2 ml-2">

            <div class="row" v-for="(organizationalUnitPerson, index) in personOrganizationalUnits">
              <div class="col-3">
                <div class="form-group">
                  <select 
                    class="form-control"  
                    v-model="organizationalUnitPerson.organizational_type_unit_id"
                    @change="updateOrganizationalUnitsTypeForUpdateRow($event.target.value,index)"  
                  >
                    <option value=''>---</option>
                    <option v-for="organizationalUnitType in org_unit_type" :value="organizationalUnitType.id">
                      {{ organizationalUnitType.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <select class="form-control" :name='"personOrganizationalUnit[" + index + "][organizational_unit]"'
                    v-model="organizationalUnitPerson.organizational_unit_id">
                    <option v-for="organizationalUnit in selectForOrganizationalUnits[index]" :value="organizationalUnit.id">
                      {{ organizationalUnit.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-1">
                <div class="form-group">
                  <input type="number" class="form-control" :name='"personOrganizationalUnit[" + index + "][fte_uo]"'
                    v-model="organizationalUnitPerson.fte_uo" min="1" max="100">
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <input type="date" class="form-control" :name='"personOrganizationalUnit[" + index + "][started_at]"'
                    v-model="organizationalUnitPerson.started_at">
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <input type="date" class="form-control" :name='"personOrganizationalUnit[" + index + "][ended_at]"'
                    v-model="organizationalUnitPerson.ended_at">
                </div>
              </div>
              <div class="col-1">
                <div class="form-group">
                  <button @click="deletePersonOrganizationalUnit(index)" type="button"
                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-remove mx-1">
                    <i class="fas fa-trash"></i><span></span>
                  </button>
                </div>
              </div>
            </div>
        </div>




        <div class="mt-4 mb-4 ml-2">
          <h6 class="text-primary">
            {{ __('forms.peopleOrganizationalUnit.addPersonOrganizationalUnit') }}
          </h6>

            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="form-label mb-1">
                   {{ __("misc.filterBy") }} {{ __('forms.OrganizationalUnit.type') }}
                  </label>
                  <select class="form-control" v-model="new_organizational_unit_type_id" @change="filterInsertOrganizationalUnits($event)">
                    <option value=''>---</option>
                    <option value="0">{{ __("misc.no_typology") }}</option>
                    <option v-for="organizationalUnitType in org_unit_type" :value="organizationalUnitType.id">
                      {{ organizationalUnitType.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-3">
                <div class="form-group">
                  <label class="form-label mb-1">
                    {{ __('forms.OrganizationalUnit.unit') }}
                  </label>
                  <select class="form-control" v-model="new_organizational_unit_id">
                    <option v-for="organizationalUnit in organizationalUnitsFilteredByUnit" :value="organizationalUnit.id">
                      {{ organizationalUnit.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-1">
                <div class="form-group">
                  <label class="form-label mb-1">
                    {{ __('forms.PeopleRoles.fte') }}
                  </label>
                  <input type="number" min="1" max="100" class="form-control" v-model="new_fte_uo">
                </div>
              </div>
              <div class="col-2">
                <div class="form-group">
                  <label class="form-label mb-1">
                    {{ __('views.trainingRequestCourse.started_at') }}
                  </label>
                  <input type="date" class="form-control" v-model="new_started_at">
                </div>
              </div>
              
              <div class="col-2">

              </div>
              <div class="col-1">
                <div class="form-group">
                  <label class="form-label d-none d-lg-block mb-lg-2">
                    {{ __('views.trainingRequests.actions') }}
                  </label>
                  <button @click="storePersonOrganizationalUnit()" type="button"
                    class="btn btn--mini btn--only-icon btn--transparent circle-button circle-button-edit mx-1"> <i
                      class="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn btn--green" type="submit">{{ __("misc.save") }}
          </button>
        </div>
      </form>
    </div>


  </div>
</template>

<script>
export default {
  mounted() {
    this.populateOrganizationalUnits();
    
    this.organizationalUnitsFilteredByUnit = []; 
  },

  data() {
    return {
      organizationalUnitsFilteredByUnit : [],
      personOrganizationalUnits: [],

      selectForOrganizationalUnits : [],

      new_organizational_unit_id: null,
      new_organizational_unit_type_id: null,
      new_started_at: null,
      new_fte_uo: null,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },

  methods: { 

    filterInsertOrganizationalUnits( event ){
 
      let value = event.target.value;
      let data = this.filterUpdateOrganizationalUnits(value);
      
      this.organizationalUnitsFilteredByUnit = [];
      this.organizationalUnitsFilteredByUnit = this.filterUpdateOrganizationalUnits(value);
    },

    updateOrganizationalUnitsTypeForUpdateRow(type_id, indexRow){

      this.selectForOrganizationalUnits[indexRow] = this.filterUpdateOrganizationalUnits(type_id);
    },

    filterUpdateOrganizationalUnits(type_id){
             
      if ( type_id === null ){  
        return [];
      }
      if ( type_id == 0 ){
        type_id = null;
      }

      return this.organizational_units.filter( organizational_unit =>organizational_unit.organizational_unit_type_id == type_id  );
    },

    

    storePersonOrganizationalUnit() {
      if (this.new_organizational_unit_id == null) {
        alert("Non hai selezioanto la unità organizzativa");
      } else {
        let peopleOrganizationalUnit = {
          person_id: this.person.id,
          organizational_unit_id: this.new_organizational_unit_id,          
          organizational_type_unit_id: this.new_organizational_unit_type_id,
          started_at: this.new_started_at,
          fte_uo: this.new_fte_uo
        }          
        this.personOrganizationalUnits.push(peopleOrganizationalUnit);

        this.updateOrganizationalUnitsTypeForUpdateRow(this.new_organizational_unit_type_id, this.personOrganizationalUnits.length - 1);

        //Clean add
        this.organizationalUnitsFilteredByUnit = [];
        this.new_organizational_unit_type_id = null;
        this.new_started_at = null;
        this.new_fte_uo = null;
      }
    },

    deletePersonOrganizationalUnit(index) {

      Vue.swal.fire({
            title: this.__("misc.delete_confirm_message"),
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: this.__("misc.no"),
            confirmButtonText: this.__("misc.yes"),
        }).then((result) => {
            if (result.value) {
              Vue.delete(this.personOrganizationalUnits, index);
            }
        });
    },

    populateOrganizationalUnits() {
      axios.get("/person-organizational-units/" + this.person.id + "/data", { params: {} })
        .then((response) => {
          this.personOrganizationalUnits = response.data;
          this.new_organizational_unit_type_id = null;
          this.new_organizational_unit_id = null;
          this.new_started_at = null;
          this.new_fte_uo = null;
          
          //Create array content for every OrgUnits
          this.setupSelectOptionsForUpdateOrganizationalUnits();
        })
        .catch(function (error) { 

        });
    },

    setupSelectOptionsForUpdateOrganizationalUnits(){

        this.selectForOrganizationalUnits = [];
        
        for(let index = 0;index < this.personOrganizationalUnits.length ; index++ ){

          this.selectForOrganizationalUnits[index] = this.filterUpdateOrganizationalUnits( this.personOrganizationalUnits[index].organizational_type_unit_id );
        }
         
    },


  },
  props: {
    person: {
      type: Object,
      required: true
    },
    organizational_units: {
      type: Array,
      required: true
    },
    org_unit_type: {
      type: Array,
      required: true
    }
  }
}
</script>
